import { render, staticRenderFns } from "./JobsNew.vue?vue&type=template&id=08fca680&"
import script from "./JobsNew.vue?vue&type=script&lang=js&"
export * from "./JobsNew.vue?vue&type=script&lang=js&"
import style0 from "./JobsNew.vue?vue&type=style&index=0&id=08fca680&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobsJobFeed: require('/opt/build/repo/components/Jobs/JobFeed.vue').default})
